// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-4d352b50] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.list-item__wrapper[data-v-4d352b50] {
  position: relative;
  width: 100%;
}
.list-item__wrapper--active .list-item[data-v-4d352b50],
.list-item__wrapper:active .list-item[data-v-4d352b50],
.list-item__wrapper.active .list-item[data-v-4d352b50] {
  background-color: var(--color-primary-element);
}
.list-item__wrapper--active .list-item[data-v-4d352b50]:active,
.list-item__wrapper--active .list-item[data-v-4d352b50]:hover,
.list-item__wrapper--active .list-item[data-v-4d352b50]:focus,
.list-item__wrapper--active .list-item[data-v-4d352b50]:focus-visible,
.list-item__wrapper:active .list-item[data-v-4d352b50]:active,
.list-item__wrapper:active .list-item[data-v-4d352b50]:hover,
.list-item__wrapper:active .list-item[data-v-4d352b50]:focus,
.list-item__wrapper:active .list-item[data-v-4d352b50]:focus-visible,
.list-item__wrapper.active .list-item[data-v-4d352b50]:active,
.list-item__wrapper.active .list-item[data-v-4d352b50]:hover,
.list-item__wrapper.active .list-item[data-v-4d352b50]:focus,
.list-item__wrapper.active .list-item[data-v-4d352b50]:focus-visible {
  background-color: var(--color-primary-element-hover);
}
.list-item__wrapper--active .line-one__name[data-v-4d352b50],
.list-item__wrapper--active .line-one__details[data-v-4d352b50],
.list-item__wrapper:active .line-one__name[data-v-4d352b50],
.list-item__wrapper:active .line-one__details[data-v-4d352b50],
.list-item__wrapper.active .line-one__name[data-v-4d352b50],
.list-item__wrapper.active .line-one__details[data-v-4d352b50],
.list-item__wrapper--active .line-two__subname[data-v-4d352b50],
.list-item__wrapper:active .line-two__subname[data-v-4d352b50],
.list-item__wrapper.active .line-two__subname[data-v-4d352b50] {
  color: var(--color-primary-element-text) !important;
}
.list-item[data-v-4d352b50] {
  display: block;
  position: relative;
  flex: 0 0 auto;
  justify-content: flex-start;
  padding: 8px 10px;
  border-radius: 32px;
  margin: 2px 0;
  width: 100%;
  cursor: pointer;
  transition: background-color var(--animation-quick) ease-in-out;
  list-style: none;
}
.list-item[data-v-4d352b50]:active,
.list-item[data-v-4d352b50]:hover,
.list-item[data-v-4d352b50]:focus,
.list-item[data-v-4d352b50]:focus-visible {
  background-color: var(--color-background-hover);
}
.list-item-content__wrapper[data-v-4d352b50] {
  display: flex;
  align-items: center;
  height: 48px;
}
.list-item-content__wrapper--compact[data-v-4d352b50] {
  height: 36px;
}
.list-item-content__wrapper--compact .line-one[data-v-4d352b50],
.list-item-content__wrapper--compact .line-two[data-v-4d352b50] {
  margin-top: -4px;
  margin-bottom: -4px;
}
.list-item-content[data-v-4d352b50] {
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
  padding-left: 8px;
}
.list-item-content__main[data-v-4d352b50] {
  flex: 1 1 auto;
  width: 0;
  margin: auto 0;
}
.list-item-content__main--oneline[data-v-4d352b50] {
  display: flex;
}
.list-item-content__actions[data-v-4d352b50] {
  flex: 0 0 auto;
  align-self: center;
  justify-content: center;
  margin-left: 4px;
}
.list-item__extra[data-v-4d352b50] {
  margin-top: 4px;
}
.line-one[data-v-4d352b50] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  margin: 0 auto 0 0;
  overflow: hidden;
}
.line-one__name[data-v-4d352b50] {
  overflow: hidden;
  flex-grow: 1;
  cursor: pointer;
  text-overflow: ellipsis;
  color: var(--color-main-text);
  font-weight: 700;
}
.line-one__details[data-v-4d352b50] {
  color: var(--color-text-maxcontrast);
  margin: 0 8px;
  font-weight: 400;
}
.line-two[data-v-4d352b50] {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  white-space: nowrap;
}
.line-two--bold[data-v-4d352b50] {
  font-weight: 700;
}
.line-two__subname[data-v-4d352b50] {
  overflow: hidden;
  flex-grow: 1;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--color-text-maxcontrast);
}
.line-two__additional_elements[data-v-4d352b50] {
  margin: 2px 4px 0;
  display: flex;
  align-items: center;
}
.line-two__indicator[data-v-4d352b50] {
  margin: 0 5px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-4e03d941.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;;;EAGE,8CAA8C;AAChD;AACA;;;;;;;;;;;;EAYE,oDAAoD;AACtD;AACA;;;;;;;;;EASE,mDAAmD;AACrD;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,eAAe;EACf,+DAA+D;EAC/D,gBAAgB;AAClB;AACA;;;;EAIE,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-4d352b50] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.list-item__wrapper[data-v-4d352b50] {\n  position: relative;\n  width: 100%;\n}\n.list-item__wrapper--active .list-item[data-v-4d352b50],\n.list-item__wrapper:active .list-item[data-v-4d352b50],\n.list-item__wrapper.active .list-item[data-v-4d352b50] {\n  background-color: var(--color-primary-element);\n}\n.list-item__wrapper--active .list-item[data-v-4d352b50]:active,\n.list-item__wrapper--active .list-item[data-v-4d352b50]:hover,\n.list-item__wrapper--active .list-item[data-v-4d352b50]:focus,\n.list-item__wrapper--active .list-item[data-v-4d352b50]:focus-visible,\n.list-item__wrapper:active .list-item[data-v-4d352b50]:active,\n.list-item__wrapper:active .list-item[data-v-4d352b50]:hover,\n.list-item__wrapper:active .list-item[data-v-4d352b50]:focus,\n.list-item__wrapper:active .list-item[data-v-4d352b50]:focus-visible,\n.list-item__wrapper.active .list-item[data-v-4d352b50]:active,\n.list-item__wrapper.active .list-item[data-v-4d352b50]:hover,\n.list-item__wrapper.active .list-item[data-v-4d352b50]:focus,\n.list-item__wrapper.active .list-item[data-v-4d352b50]:focus-visible {\n  background-color: var(--color-primary-element-hover);\n}\n.list-item__wrapper--active .line-one__name[data-v-4d352b50],\n.list-item__wrapper--active .line-one__details[data-v-4d352b50],\n.list-item__wrapper:active .line-one__name[data-v-4d352b50],\n.list-item__wrapper:active .line-one__details[data-v-4d352b50],\n.list-item__wrapper.active .line-one__name[data-v-4d352b50],\n.list-item__wrapper.active .line-one__details[data-v-4d352b50],\n.list-item__wrapper--active .line-two__subname[data-v-4d352b50],\n.list-item__wrapper:active .line-two__subname[data-v-4d352b50],\n.list-item__wrapper.active .line-two__subname[data-v-4d352b50] {\n  color: var(--color-primary-element-text) !important;\n}\n.list-item[data-v-4d352b50] {\n  display: block;\n  position: relative;\n  flex: 0 0 auto;\n  justify-content: flex-start;\n  padding: 8px 10px;\n  border-radius: 32px;\n  margin: 2px 0;\n  width: 100%;\n  cursor: pointer;\n  transition: background-color var(--animation-quick) ease-in-out;\n  list-style: none;\n}\n.list-item[data-v-4d352b50]:active,\n.list-item[data-v-4d352b50]:hover,\n.list-item[data-v-4d352b50]:focus,\n.list-item[data-v-4d352b50]:focus-visible {\n  background-color: var(--color-background-hover);\n}\n.list-item-content__wrapper[data-v-4d352b50] {\n  display: flex;\n  align-items: center;\n  height: 48px;\n}\n.list-item-content__wrapper--compact[data-v-4d352b50] {\n  height: 36px;\n}\n.list-item-content__wrapper--compact .line-one[data-v-4d352b50],\n.list-item-content__wrapper--compact .line-two[data-v-4d352b50] {\n  margin-top: -4px;\n  margin-bottom: -4px;\n}\n.list-item-content[data-v-4d352b50] {\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: space-between;\n  padding-left: 8px;\n}\n.list-item-content__main[data-v-4d352b50] {\n  flex: 1 1 auto;\n  width: 0;\n  margin: auto 0;\n}\n.list-item-content__main--oneline[data-v-4d352b50] {\n  display: flex;\n}\n.list-item-content__actions[data-v-4d352b50] {\n  flex: 0 0 auto;\n  align-self: center;\n  justify-content: center;\n  margin-left: 4px;\n}\n.list-item__extra[data-v-4d352b50] {\n  margin-top: 4px;\n}\n.line-one[data-v-4d352b50] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  margin: 0 auto 0 0;\n  overflow: hidden;\n}\n.line-one__name[data-v-4d352b50] {\n  overflow: hidden;\n  flex-grow: 1;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  color: var(--color-main-text);\n  font-weight: 700;\n}\n.line-one__details[data-v-4d352b50] {\n  color: var(--color-text-maxcontrast);\n  margin: 0 8px;\n  font-weight: 400;\n}\n.line-two[data-v-4d352b50] {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  white-space: nowrap;\n}\n.line-two--bold[data-v-4d352b50] {\n  font-weight: 700;\n}\n.line-two__subname[data-v-4d352b50] {\n  overflow: hidden;\n  flex-grow: 1;\n  cursor: pointer;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: var(--color-text-maxcontrast);\n}\n.line-two__additional_elements[data-v-4d352b50] {\n  margin: 2px 4px 0;\n  display: flex;\n  align-items: center;\n}\n.line-two__indicator[data-v-4d352b50] {\n  margin: 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
